import * as React from 'react';

import { ModalFrameFooter, ModalFrameInner } from 'components/modal';
import ActionButton from 'components/buttons/action-button/ActionButton';
import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import { __t, applyTranslations } from 'utils/language';

import './campaign-acceptance-step.scss';

applyTranslations(require('./campaign-acceptance-step.i18n.json'));

type Props = {
  campaignName: string,
  brandName?: string | null,
  minHeight: number,
  onClose: () => void,
  onNextStep: () => void
};

const CampaignAcceptanceStep = ({ minHeight, campaignName, brandName, onClose, onNextStep }: Props) => (
  <React.Fragment>
    <ModalFrameInner
      minHeight={minHeight}
      verticalAlign="center"
    >
      <div className="campaign-acceptance-step__title">
        {__t('campaign_acceptance_step.title')}
      </div>
      <div className="campaign-acceptance-step__image">
        <SVGDynamicIcon
          name="hand-snap-inside-circle-custom-fg"
          width={170}
          height={170}
          customColor="primary"
        />
      </div>
      <div
        className="campaign-acceptance-step__message"
        dangerouslySetInnerHTML={{ __html: __t('campaign_acceptance_step.message', {
          campaignName,
          brandName: (brandName || '').slice(-1) === 's' ? brandName : `${brandName}'s`
        }) }}
      />
    </ModalFrameInner>
    <ModalFrameFooter>
      <ActionButton
        color="secondary"
        onClick={onClose}
        key="button-close"
        className="campaign-acceptance-step__clost-btn"
      >
        {__t('campaign_acceptance_step.btn_close')}
      </ActionButton>
      <ActionButton
        color="primary"
        onClick={onNextStep}
        key="button-accept"
      >
        {__t('campaign_acceptance_step.btn_learn_how_campaign_works')}
      </ActionButton>
    </ModalFrameFooter>
  </React.Fragment>
);

export default CampaignAcceptanceStep;
